define('app/visualizations/FormatFactory',['require','glu/util','moment','d3'],function(require) {
	'use strict';

	var _ = require('glu/util');
	var moment = require('moment');
	var d3 = require('d3');

	var SECONDS_IN_A_MINUTE = 60;
	var SECONDS_IN_AN_HOUR = 60 * SECONDS_IN_A_MINUTE;
	var SECONDS_IN_A_DAY = 24 * SECONDS_IN_AN_HOUR;

	/* DUMMYTYPE is just for unit testing. */
	var DummyFormatter = function() {
		return function(n) {
			return '~' + n + '~';
		};
	};

	var DecFormatter = function() {
		return function(n) {
			if (n === null || n === '') {
				return '';
			}
			return parseFloat(n).toFixed(2);
		};
	};
	var CurrencyFormatter = function() {
		return function(n) {
			if (n === null || n === '') {
				return '';
			}
			return d3.format('$,.2f')(parseFloat(n));
		};
	};
	var PercentFormatter = function(total) {
		return function(n) {
			if (n === null || n === '') {
				return '';
			}
			var percent = parseFloat(n) * 100 / total;
			return parseFloat(percent).toFixed(1) + '%';
		};
	};
	var TimespanFormatter = function() {
		return function(seconds) {
			if (seconds === null || seconds === '') {
				return '';
			}

			var remainingSeconds = seconds;
			var days = Math.floor(remainingSeconds / SECONDS_IN_A_DAY);
			remainingSeconds = remainingSeconds - days * SECONDS_IN_A_DAY;
			var hours = Math.floor(remainingSeconds / SECONDS_IN_AN_HOUR);
			remainingSeconds = remainingSeconds - hours * SECONDS_IN_AN_HOUR;
			var minutes = Math.round(remainingSeconds / SECONDS_IN_A_MINUTE);

			if (minutes === 60) {
				minutes = 0;
				hours++;
			}

			if (hours === 24) {
				hours = 0;
				days++;
			}

			var dayPart = '';
			if (days > 0) {
				dayPart = days + 'd ';
			}

			var hourPart = '';
			if (hours > 0 || days > 0) {
				hourPart = hours + 'h ';
			}

			var minutePart = minutes + 'm';

			return dayPart + hourPart + minutePart;
		};
	};

	var DateTimeFormatter = function() {
		return function(sDate) {
			if (_.isNaN(sDate) || _.isNull(sDate) || _.isUndefined(sDate) || sDate === '') {
				return '';
			}

			var m = moment(sDate);
			if (!m.isValid()) {
				return sDate;
			}

			//Mar 28 2015 - 5:45 PM
			return m.format('MMM DD YYYY - h:mm A');
		};
	};

	var DateFormatter = function() {
		return function(sDate) {
			if (_.isNaN(sDate) || _.isNull(sDate) || _.isUndefined(sDate) || sDate === '') {
				return '';
			}

			var m = moment(sDate);
			if (!m.isValid()) {
				return sDate;
			}

			//Mar 28 2015
			return m.format('MMM DD YYYY');
		};
	};

	var EnumFormatter = function(enumeration) {
		return function(n) {
			if (enumeration && !_.isUndefined(enumeration[n])) {
				return enumeration[n];
			} else {
				return n;
			}
		};
	};

	//formats : '2015-01'  into : '2015-January'
	var customFormatterYearMonth = function(n) {
		if (!n) {
			return n;
		}
		var ar = n.toString().split('-');
		if (ar.length > 1) {
			switch (ar[1]) {
				case '01':
					ar[1] = 'January';
					break;
				case '02':
					ar[1] = 'February';
					break;
				case '03':
					ar[1] = 'March';
					break;
				case '04':
					ar[1] = 'April';
					break;
				case '05':
					ar[1] = 'May';
					break;
				case '06':
					ar[1] = 'June';
					break;
				case '07':
					ar[1] = 'July';
					break;
				case '08':
					ar[1] = 'August';
					break;
				case '09':
					ar[1] = 'September';
					break;
				case '10':
					ar[1] = 'October';
					break;
				case '11':
					ar[1] = 'November';
					break;
				case '12':
					ar[1] = 'December';
					break;
			}
		}
		return ar.join('-');
	};

	var customFormatterTime = function(time) {
		if (_.isFinite(time)) {
			var hours = Math.floor(time / 60),
				minutes = Math.floor(time - (hours * 60));
			var m = moment(hours + ':' + minutes, 'HH:mm');
			// Data has to be a number, so we'll use 24h time with no ":"
			return m.format('h:mm A');
		} else {
			return time;
		}
	};

	var PreFormattedPercentFormatter = function(n) {
		if (n === null || n === '') {
			return '';
		}
		return d3.format(',.3f')(parseFloat(n)) + '%';
	};

	var PreFormattedPercent01Formatter = function(n) {
		if (n === null || n === '') {
			return '';
		}
		return d3.format(',.1f')(parseFloat(n)) + '%';
	};

	return {

		//TODO: perhaps later we could have an array of custom formatters, and use the full formatter name
		//	instead of having the code to switch (like 'year-month' into appropriate function to return)
		customFormatter: function(displayFormat) {
			switch (displayFormat) {
				case 'year-month':
					return customFormatterYearMonth;
				case 'time':
					return customFormatterTime;
				case 'percentage':
					return PreFormattedPercentFormatter;
				case 'percentage01':
					return PreFormattedPercent01Formatter;
				default:
					throw new Error('Unknown custom displayFormat="' + displayFormat + '"');
			}
		},


		/**
		 * Return formatter for a given column type and aggregation
		 * @param {type} Required. Column type.
		 * @param {options} Optional. Additional format options, currently use enumeration and aggregation only.
		 * @return {Function} formatter
		 */
		formatterForType: function(type, options) {

			if (options && options.displayFormat) {
				if ((options && options.aggregation && options.aggregation !== 'COUNT' && options.aggregation !== 'COUNTD') || (options && !options.aggregation) || !options) {
					return this.customFormatter(options.displayFormat);
				} else {
					return _.identity;
				}
			} else {
				switch (type) {
					case 'DUMMYTYPE':
						return new DummyFormatter();
					case 'DEC':
						if (options && options.percentage) {
							return new PercentFormatter(options.percentage.total);
						}
						return new DecFormatter();
					case 'CURRENCY':
						if (options && options.percentage) {
							return new PercentFormatter(options.percentage.total);
						}
						if ((options && options.aggregation && options.aggregation !== 'COUNT' && options.aggregation !== 'COUNTD') || (options && !options.aggregation) || !options) {
							return new CurrencyFormatter();
						} else {
							return _.identity;
						}
						case 'INT':
							if (options && options.percentage) {
								return new PercentFormatter(options.percentage.total);
							}
							if (options && (options.aggregation === 'STDDEV' || options.aggregation === 'AVG')) {
								return new DecFormatter();
							}
							return _.identity;
						case 'TIMESPAN':
							if (options && options.percentage) {
								return new PercentFormatter(options.percentage.total);
							}
							if ((options && options.aggregation && options.aggregation !== 'COUNT' && options.aggregation !== 'COUNTD') || (options && !options.aggregation) || !options) {
								return new TimespanFormatter();
							} else {
								return _.identity;
							}
							case 'DATETIME':
								if ((options && options.aggregation && options.aggregation !== 'COUNT' && options.aggregation !== 'COUNTD') || (options && !options.aggregation) || !options) {
									return new DateTimeFormatter();
								} else {
									return _.identity;
								}
								case 'DATE':
									if ((options && options.aggregation && options.aggregation !== 'COUNT' && options.aggregation !== 'COUNTD') || (options && !options.aggregation) || !options) {
										return new DateFormatter();
									} else {
										return _.identity;
									}
									case 'ENUM':
										if (options && options.enumeration && !options.aggregation) {
											return new EnumFormatter(options.enumeration);
										} else {
											return _.identity;
										}
										default:
											return _.identity;
				}
			}
		}
	};
});

